/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/EnableAutomationHub/Content"
  
}) {
  return null
}